var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeforeMon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.042,
    height: 17.564,
    viewBox: "0 0 10.042 17.564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M14.278,14.974l6.646-6.641A1.255,1.255,0,1,0,19.146,6.56l-7.53,7.524a1.253,1.253,0,0,0-.037,1.731l7.561,7.577a1.255,1.255,0,1,0,1.778-1.773Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeMon);
export default __webpack_public_path__ + "static/media/before-mon.2443ddcbc5923ebc45bd9023de9a81ac.svg";
export { ForwardRef as ReactComponent };